import Excel from 'exceljs'
import * as R from 'ramda'
import moment from 'moment'
import numeral from 'numeral'
import { getCellValue } from './ExportComponentsExcel'
// import { DATE_TIME_FORMAT_UI } from './enum'

const DATE_TIME_FORMAT_UI = 'MM/DD/YYYY HH:mm:ss'

export const getWorkbook = byUser => {
  const workbook = new Excel.Workbook()

  const now = new Date()

  workbook.creator = byUser
  workbook.lastModifiedBy = byUser
  workbook.created = now
  workbook.modified = now
  workbook.lastPrinted = now

  // Set workbook dates to 1904 date system
  workbook.properties.date1904 = true

  // Force workbook calculation on load
  workbook.calcProperties.fullCalcOnLoad = true

  return workbook
}

// export const toXlsxColFromGridHeaders = (headers) =>
//   headers.map((col) => {
//     const colWidth = col.ident.length * 2
//     return {
//       header: col.display,
//       key: col.ident,
//       width: colWidth > 10 ? colWidth : 10,
//     }
//   })

// export const toXlsxDataFromGridHeaders = (data, headers) => {
//   const columnMap = R.zipObj(
//     headers.map((col) => col.ident),
//     headers
//   )
//   return data
//     .map((row) => {
//       if (row.modificationInfo == null) return null
//       else
//         return {
//           ...row,
//           modifier: row.modificationInfo.user,
//           modifiedDate: row.modificationInfo.modDate,
//         }
//     })
//     .map((row) =>
//       R.mapObjIndexed((val, key) => {
//         const col = columnMap[key]
//         if (col == null) return null
//         if (col.type === 'num') return val && +val
//         return val
//       }, row)
//     )
// }

export const toXlsxColumns = columns =>
  columns.map(col => {
    const colWidth = col.display.length * 2
    return {
      header: col.display,
      display: col.display,
      key: col.id || col.ident,
      width: (col.width && col.width / 8) || (colWidth > 8 ? colWidth : 12),
      type: col.type,
      displayFormat: col.excelFormat || col.displayFormat,
    }
  })

export const toXlsxData = (data, columnHeaders) => {
  const exportData = data.map(row => {
    return columnHeaders
      .map(header => {
        const newHeader = { ...header, ident: header.ident || header.id }
        const { ident } = newHeader
        let val = ''
        if (ident === 'modifier') {
          val =
            row.modificationInfo === undefined ? '' : row.modificationInfo.user
        } else if (ident === 'modifiedDate') {
          val =
            row.modificationInfo === undefined
              ? ''
              : moment(row.modificationInfo.modDate).format(
                  'MM/DD/YYYY HH:mm:ss'
                )
        } else {
          val = getCellValue(newHeader, row)
        }
        return { [ident]: val }
      })
      .reduce((a, b) => ({ ...a, ...b }), {})
  })

  return exportData
}

export const columnToGridHeaders = headers => {
  return headers.map(col => {
    const colWidth = col.display.length * 10
    const displayFormat = col.displayFormat

    return {
      display: col.display,
      ident: col.id || col.ident,
      width: col.width || (colWidth > 150 ? colWidth : 150),
      alignment: (col.alignment && col.alignment.toLowerCase()) || 'center',
      type: col.type || 'str',
      ellipsis: true,
      dataType:
        col.dataType || col.type === 'num'
          ? 'NUMBER'
          : col.type === 'date-time' || col.type === 'date'
          ? 'TIMESTAMP'
          : 'STRING',
      dataFormatter: ({ value, rowData }) => {
        if (col.dataFormatter) return col.dataFormatter({ value, rowData })
        if (value == null) return value

        if (
          col.dataType === 'DATE' ||
          col.dataType === 'TIMESTAMP' ||
          col.type === 'date-time'
        ) {
          return moment(value).format(displayFormat || DATE_TIME_FORMAT_UI)
        }

        if (col.dataType === 'NUMBER' || col.type === 'num') {
          return numeral(value).format(displayFormat || '#,#.##')
        }
        return value
      },
    }
  })
}

export const writeToExcel = async (worksheets, user = '') => {
  const workbook = getWorkbook(user)

  // eslint-disable-next-line no-unused-vars
  worksheets.forEach((ws, index) => {
    const worksheet = workbook.addWorksheet(ws.name || 'sheet1')
    worksheet.columns = ws.columns.map(item => ({ width: item.width }))

    const metaInfoGridHeaders = generateGridHeaderForMetaInfo(ws.metaInfo)
    const metaInfoMap = generateMetaInfoMap(ws.metaInfo)
    const metaHeaders = getHeadersFromMap(metaInfoMap)

    const metaHeadersCount = metaHeaders.length

    const metaHeaderStartRow = 1
    fillMetaData(
      worksheet,
      metaInfoGridHeaders,
      metaHeaders,
      metaHeaderStartRow
    )

    // const headerBackground = ws.headerBackgroundARGB || 'ff85edff'

    const headerRow = metaHeadersCount + 1
    const header = worksheet.getRow(headerRow)
    ws.columns.forEach((col, index) => {
      const cell = header.getCell(index + 1)
      // cell.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: headerBackground },
      // }
      cell.font = { bold: true }
      cell.value = col.header
    })

    // const dataCount = ws.data.length
    //   const colorInfoMap = getColorInfoMapFromList(ws.colorInfo)
    const dataStartRow = headerRow + 1
    ws.data.forEach((item, rowIndex) => {
      const row = worksheet.getRow(rowIndex + dataStartRow)
      ws.columns.forEach((col, index) => {
        const cell = row.getCell(index + 1)
        let value = item[col.key]
        if (col.type === 'num' && value) {
          cell.numFmt = col.displayFormat
          value = (value || '').replaceAll('$', '').replaceAll(',', '')
          value = parseFloat(value)
          cell.value = value
        }
        // else if (col.key === 'modifier') {
        //   cell.value = item.modifier || item?.modificationInfo?.user
        // } else if (col.key === 'modifiedDate') {
        //   cell.value = item.modifiedDate || item?.modificationInfo?.modDate
        // }
        else cell.value = item[col.key]

        const bgColor =
          ws?.getBgColor && ws.getBgColor({ rowData: item, header: col })
        if (bgColor) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ff' + bgColor },
          }
        }

        // cell.type = getCellType(col, item[col.key])

        //   const color = getColorFromColorInfoMap(item.row, col.key, colorInfoMap)
        //   if (color != null) {
        //     cell.fill = {
        //       type: 'pattern',
        //       pattern: 'solid',
        //       fgColor: {
        //         argb: 'ff' + color,
        //       },
        //     }
        //   }
      })
    })
  })

  // const metaFooters = getFootersFromMap(metaInfoMap)
  // const footerStartRow = dataStartRow + dataCount + 1
  //   fillMetaData(worksheet, metaInfoGridHeaders, metaFooters, footerStartRow)
  // })

  const data = await workbook.xlsx.writeBuffer()

  var blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  return blob
}

export const fillMetaData = (worksheet, headers, data, startRow) => {
  data.forEach((item, rowIndex) => {
    const row = worksheet.getRow(rowIndex + startRow)
    headers.forEach((col, index) => {
      const cell = row.getCell(index + 1)
      const value = item[col.ident]
      if (value) {
        if (value.content) {
          cell.value = value.content
        }
        if (value.color) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
              argb: 'ff' + value.color,
            },
          }
        }
        cell.font = {
          bold: value.bold,
          size: value.fontSize,
        }
      }
    })
  })
}

export const getColumnCountFromMetaInfo = metaInfo => {
  return R.reduce(
    R.max,
    0,
    metaInfo.map(item => item.column)
  )
}

export const getRowCountFromMetaInfo = metaInfo => {
  return R.reduce(
    R.max,
    0,
    metaInfo.map(item => item.row)
  )
}

export const generateGridHeaderForMetaInfo = metaInfo => {
  const columnCount = getColumnCountFromMetaInfo(metaInfo)
  return [...Array(columnCount)].map((_, index) => {
    return {
      ident: index + 1 + '',
      display: index + 1 + '',
      type: 'str',
      ellipsis: true,
      width: 100,
      dataGetter: ({ rowData, header }) =>
        rowData[header.ident] && rowData[header.ident].content,
    }
  })
}

export const generateMetaInfoMap = metaInfo => {
  const newMeta = R.groupBy(item => item.position, metaInfo)
  return R.mapObjIndexed(value => {
    const rowCount = getRowCountFromMetaInfo(value)
    const grouped = R.groupBy(item => item.row, value)
    ;[...new Array(rowCount)].forEach((_, index) => {
      const val = grouped[index + 1]
      if (!val) {
        grouped[index + 1] = []
      }
    })
    return Object.values(
      R.mapObjIndexed(rowData => {
        return R.fromPairs(rowData.map(item => [item.column, item]))
      }, grouped)
    )
  }, newMeta)
}

export const getHeadersFromMap = metaInfoMap => {
  return Object.keys(metaInfoMap).flatMap(headerKey => {
    if (+headerKey <= 0) {
      const rows = metaInfoMap[headerKey]
      rows.push({})
      return rows
    } else {
      return []
    }
  })
}

// export const getFootersFromMap = (metaInfoMap) => {
//   return Object.keys(metaInfoMap).flatMap((headerKey) => {
//     if (+headerKey > 0) {
//       const rows = metaInfoMap[headerKey]
//       rows.push({})
//       return rows
//     } else {
//       return []
//     }
//   })
// }
